import { SET_ADMIN, GET_SUBJECTS } from '../actionTypes'
import isEmpty from '../validation/is-empty'

const initialState = {
    isAuthenticated: false,
    admin: {},
    adminAddFacultyFlag: false,
    adminAddStudentFlag: false,
    adminAddAdminFlag: false,
    adminAddSubjectFlag: false,
    allSubject: {},
    allSubject: [], // There's only one allSubject property now
    allFaculty: [],
    allAdmin: [],
    notices: [],
    deleteStudentZ: {},
    allStudent: [],
};

const adminReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ADMIN:
            return {
                ...state,
                isAuthenticated: !isEmpty(action.payload),
                admin: action.payload
            };
        case GET_SUBJECTS:
            return {
                ...state,
                allSubject: action.payload
            };
        case "ADMIN_ADD_FACULTY_FLAG":
            return {
                ...state,
                adminAddFacultyFlag: action.payload
            };
        case "GET_ALL_NOTICE":
            return {
                ...state,
                notices: action.payload,
            };
        case "ADMIN_ADD_STUDENT_FLAG":
            return {
                ...state,
                adminAddStudentFlag: action.payload
            };
        case "ADMIN_ADD_SUBJECT_FLAG":
            return {
                ...state,
                adminAddSubjectFlag: action.payload
            };
        case "ADMIN_ADD_ADMIN_FLAG":
            return {
                ...state,
                adminAddAdminFlag: action.payload
            };
        case "GET_ALL_FACULTY":
            return {
                ...state,
                allFaculty: action.payload
            };
        case "GET_ALL_ADMIN":
            return {
                ...state,
                allAdmin: action.payload
            };
        case "GET_DELETE_STUDENT":
            return {
                ...state,
                deleteStudentZ: action.payload
            };
            case "GET_ALL_STUDENT": {
                const sortedStudents = action.payload.slice().sort((a, b) => {
                    const yearOrder = { I: 1, II: 2, III: 3, IV: 4, PassedOut: 5 };
            
                    const yearA = yearOrder[a.year] || Infinity;
                    const yearB = yearOrder[b.year] || Infinity;
            
                    // If the years are the same, then sort by registrationNumber
                    if (yearA === yearB) {
                        return a.registrationNumber.localeCompare(b.registrationNumber);
                    }
            
                    return yearA - yearB;
                });
            
                return {
                    ...state,
                    allStudent: sortedStudents
                };
            }
            
            
            
        case "GET_ALL_SUBJECT":
            return {
                ...state,
                allSubject: action.payload
            };
        default:
            return state;
    }
};

export default adminReducer;
